import { HttpResponse, http } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import type { FetchTourItinerariesApiResponse } from '../../../src/store/facade/facadeApiV3';
import { itineraryAutomatedMock } from '../data/itinerariesMock';

const calculateURL = `${BASE_URL_V3}${API.endpoints.tour}/:tourId${API.endpoints.itineraries}`;
export const calculateSuccessHandler = http.get(calculateURL, () => {
    const response: FetchTourItinerariesApiResponse = { itineraries: itineraryAutomatedMock.itineraries };
    return HttpResponse.json(response, { status: 200 });
});

export const calculateEmptyHandler = http.get(calculateURL, () => HttpResponse.json({ itineraries: [] }));

export const calculateItinerariesResource = {
    success: calculateSuccessHandler,
    error: undefined,
    empty: calculateEmptyHandler,
};

const selectURL = `${BASE_URL_V3}${API.endpoints.tour}/:tourId${API.endpoints.itineraries}/:itineraryId`;
export const SelectSuccessHandler = http.post(selectURL, () => {
    return new HttpResponse(null, { status: 200 });
});

export const selectItinerariesResource = {
    success: SelectSuccessHandler,
    error: undefined,
    empty: undefined,
};
